<template>
  <div class="" :id="this.$route.name">
    <Card back tools toolsColumns>
      <template v-slot:header>
        <h4 class="d-inline">لیستـ کاربران CRM</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="mb-3 mt-3">
          <a class="d-inline float-right mx-2 mt-1" href="javascript:;" v-if="AddMode == 0" @click="AddMode = 1" title="افزودن سمت">
            <h4>
              <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
            </h4>
          </a>
          <a
            class="d-inline float-right mx-2 mt-1"
            href="javascript:;"
            v-if="AddMode == 1 || AddMode == -1"
            @click="
              AddMode = 0
              Reload()
            "
            title="لغو افزودن"
          >
            <h4>
              <i class="fas fa-times text-danger"></i>
            </h4>
          </a>
        </div>
        <div id="PersonelCRM" v-if="AddMode == 1 || AddMode == -1" class="p-2 mb-2 d-block">
          <div class="row mt-4">
            <div class="col-md-6 col-12">
              <small id="LblTblCostomer">انتخاب مشتری</small>
              <SearchableCombo
                :edit="false"
                :grp="0"
                :code="null"
                @ResultCombo="GetResulTblCostomer"
                :defaultvalue="DataAxios.tblCustomerId"
                :rownumintable="3"
                :action="'TblCrmCombo/GetCostomerProduct'"
                :method="'POST'"
                :idinput="'TblCostomer'"
                :keyItem="'TblCostomer'"
                :disabled="tblCustomerId != null"
                :ClassProps="'required'"
              >
              </SearchableCombo>
            </div>
            <div v-if="AddMode != -1" class="col-md-3 col-12">
              <small id="LblTblCostomer">انتخاب پرسنل</small>
              <SearchableCombo
                v-if="Render"
                :edit="false"
                :grp="DataAxios.TblCustomerId"
                :code="null"
                @ResultCombo="GetResulTblCostomerPersonel"
                :defaultvalue="DataAxios.tblPersonelId"
                :rownumintable="3"
                :action="'TblCrmCombo/GetPersonelComboTicket'"
                :method="'POST'"
                :idinput="'TblCostomerPersonel'"
                :keyItem="'TblCostomerPersonel'"
                :disabled="DataAxios.TblCustomerId == null"
                :ClassProps="'required'"
              >
              </SearchableCombo>
            </div>
            <div v-else class="col-md-3 col-12 text-center">
              <div class="mt-4">
                <h4>{{ DataAxios.FullName }}</h4>
              </div>
            </div>
            <div class="col-md-3 col-12">
              <small id="LblTblCostomer">انتساب سمت</small>
              <SearchableCombo
                :edit="false"
                :grp="0"
                :code="null"
                @ResultCombo="GetResulGrpPersonel"
                :defaultvalue="DataAxios.tblGrpId"
                :rownumintable="3"
                :action="'PersonelTicket/Get_GrpCustomer'"
                :method="'get'"
                :idinput="'TblGrpPersonel'"
                :keyItem="'TblGrpPersonel'"
                :disabled="false"
                :ClassProps="'required'"
              >
              </SearchableCombo>
            </div>
            <div class="col-md-4 col-12">
              <small id="LblUserName">نام کاربری سامانه</small>
              <input type="text" class="form-control InputText required text-center" v-model="DataAxios.UserName" />
            </div>
            <div class="col-md-3 pl-3 col-12">
              <small id="LblPas">کلمه عبور سامانه</small>
              <input v-if="Render" type="text" class="form-control InputText required text-center" :class="$CusCode() == 9999 ? '' : 'required-Pass'"
               v-model="DataAxios.Pass" />
            </div>
            <div class="col-md-1 pr-0 col-12" v-if="$CusCode() == 9999">
              <div class="mt-4 text-right">
                <i class="fad fa-sync fa-2x Pointer" title="ایجاد کد رمز جدید" @click="ReRandomPass" style="color: var(--logo-color)"></i>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <button v-if="AddMode == 1" class="btn btn-success mt-4 text-center w-100" @click="SetData">ثبت اطلاعات</button>
              <button v-else-if="AddMode == -1" @click="EditCrmUser" class="btn btn-warning mt-4 text-center w-100">ویرایش اطلاعات</button>
              <button v-else class="btn btn-success mt-4 text-center w-100" @click="SetData">افزودن اطلاعات</button>
            </div>
          </div>
        </div>

        <Bnp-Grid v-if="AddMode == 0 && $store.state.renderComponentGrid" :action="true" :propsColumn="Column" :propsRows="row">
          <template slot="action-slot" slot-scope="props">
            <a href="javascript:;" class="mr-2" @click="OnEditNew(props.props)"
              ><i><span class="fas fa-marker text-secondary hover-warning"></span></i
            ></a>

            <a href="javascript:;" v-if="props.props.tuArchive" class="mr-2" @click="ChangeStatusQuestion(props.props)"
              ><i><span class="fas fa-do-not-enter text-danger hover-warning"></span></i
            ></a>
            <a href="javascript:;" v-else class="mr-2" @click="ChangeStatusQuestion(props.props)"
              ><i><span class="fas fa-check text-secondary hover-warning"></span></i
            ></a>
     
            <a href="javascript:;" v-if="props.props.UserHasBeenLocked == false" class="mr-2" data-title="قفل کاربر">
              <i class="fa-solid fa-lock-open hover-warning"></i></a>

              <a href="javascript:;" v-if="props.props.UserHasBeenLocked == true" class="mr-2" @click="UnlockUser(props.props)" data-title="قفل کاربر">
                <i class="fa-sharp fa-solid fa-lock"></i></a>


            <!-- <a href="javascript:;" class="mr-2 badge" @click="SendSmsOnGrid(props.props)"
              ><h6><span class="fal fa-sms text-secondary hover-warning"></span></h6
            ></a> -->
          </template>
        </Bnp-Grid>
      </template>
    </Card>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid'
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  data() {
    return {
      AddMode: 0,
      row: [],
      Column: [],
      DataAxios: {
        UserName: '',
      },
      Render: true,
      DataAxiosSend: {
        Action: 'PersonelTicket',
        Method: 'POST',
        ArryfildValue: {},
      },
      Rows: [],
    }
  },
  components: {
    Card,
    BnpGrid,
    SearchableCombo,
  },
  methods: {
    ChangeStatusQuestion(row) {
      var q = ' آیا از ' + (row.tuArchive ? 'فعال' : 'غیر فعال') + '  نمودن کاربر اطمینان دارید؟'
      this.$SweetQustion('تغییر وضعیت', q, 'warning', 'تغییر وضغیت', 'انصراف', row, this.changeStatus, this.Cancel)
    },
    changeStatus(data) {
      var DataAxios = { Method: 'POST', Action: 'TarifKarbaran/CahngeStatus', ArryfildValue: { Id: data.tblUserIdLogin, Usergrp: this.$session.get('UserInfo').tblUserGrpId } }
      this.$PostData(DataAxios)
        .then((response) => {
          console.log(response)
          if (response.status == 'success') {
            this.$toasted.success(response.msg, {
              duration: 2000,
            })
          } else {
            this.$toasted.error(response.msg, {
              duration: 2000,
            })
          }
        })
        .finally(() => {
          this.row.find((x) => x.tblPersonelId == data.tblPersonelId).tuArchive = !data.tuArchive
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetDataPersonel() {
      var DataAxiosEditPersonel = { Action: 'PersonelTicket', Method: 'get', ArryfildValue: null }
      this.$PostData(DataAxiosEditPersonel).then((result) => {
        this.row = result.Data
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
      })
    },
    GetColumn() {
      var DataAxoisCol = {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmPersonelTicket',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      }
      this.$GetColumns(DataAxoisCol, true)
        .then((data) => {
          this.Column = data
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetResulTblCostomer(data) {
      if (data.element) {
        this.DataAxios.TblCustomerId = data.id
        this.DataAxios.CustomerCode = Number(data.element.element)
        this.Render = false
        this.$nextTick(() => {
          this.Render = true
        })
      }
    },
    GetResulTblCostomerPersonel(data) {
      this.DataAxios.tblPersonelId = data.id
      if (data.element != null) {
        this.DataAxios.UserName = data.element.allData && data.element.allData.perMobile ? data.element.allData.perMobile : ''
        this.DataAxios.PerMobile = data.element.allData && data.element.allData.perMobile ? data.element.allData.perMobile : ''
        this.DataAxios.FullName = data.element.allData && data.element.allData.fullName ? data.element.allData.fullName : ''
        this.DataAxios.Pass = this.getRndInteger(10000, 999999) + ''
      }
    },
    getRndInteger(min, max) {
      if(this.$CusCode() == 9999){
        return Math.floor(Math.random() * (max - min)) + min
      }else{
        return null
      }
    },
    GetResulGrpPersonel(data) {
      this.DataAxios.tblGrpId = data.id
    },

    // genratePassword(length) {
    //     let result = '';
    //     const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789';
    //     const charactersLength = characters.length;
    //     let counter = 0;
    //     while (counter < length) {
    //       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    //       counter += 1;
    //     }
    //     return result;
    // },

    SetData() {
      // this.$SweetQustion('ارسال پیامک', 'اطلاعات سامانه CRM D برای پرسنل مربوطه ارسال گردد؟', 'info', 'ارسال پیامک', 'انصراف', this.DataAxios, this.SendSms, this.cancel)

      if (this.$ValidForm('PersonelCRM')) {
        this.DataAxios.tblUserGrpInsert = this.$session.get('UserInfo').tblUserGrpId
        this.DataAxios.tblUserid = this.$session.get('UserInfo').tblUserId
        this.DataAxiosSend.ArryfildValue = this.DataAxios
        this.$PostData(this.DataAxiosSend).then((result) => {
          if (result.status == 'Success') {
            this.Reload()
            this.GetDataPersonel()
            this.$SweetQustion('ارسال پیامک', 'اطلاعات سامانه CRM W برای پرسنل مربوطه ارسال گردد؟', 'info', 'ارسال پیامک', 'انصراف', this.DataAxiosSend.ArryfildValue, this.SendSms, this.cancel)
          } else {
            if (result.status == 'error') {
              this.$mySweetDefaultTost('عملیات ناموفق', result.msg, 'error', 2000)
            } else this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی در ثبت کاربر سامانه CRM  به وجود آماده', 'error', 2000)
          }
        })
      }
    },
    Reload() {
      this.DataAxios = {}
      this.AddMode = 0
    },
    ReRandomPass() {
      this.DataAxios.Pass = this.getRndInteger(10000, 999999) + ''
      this.Render = false
      this.$nextTick(() => {
        this.Render = true
      })
    },
    UnlockUser(item){
      this.$RemoveAlert('از باز کردن قفل کاربر ' + item.FullName + '؟').then((res) => {
          if (res) {
              this.$PostData_new("put", "PersonelTicket/" + item.Id).then((res) => {
                  if (res.isSuccess) {
                      this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
                      this.GetDataPersonel()
                  } else {
                      this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
                  }
              }).catch((err) => {
                  this.$mySweetDefaultTost('عملیات ناموفق', 'خطا سمت سرور', 'error', 2000)
                  console.error(err)
              })
          }
      })
    },  
    OnEditNew(row) {
      this.AddMode = -1
      this.DataAxios = row
      this.Render = false
      this.$nextTick(() => {
        this.Render = true
      })
    },
    SendSms(data) {
      if (data.PerMobile != '' && data.PerMobile != null) {
        let DataAxiosSend = {
          Action: 'Sms/SendSms',
          Method: 'POST',
          ArryfildValue: {
            TblPersonalId: data.tblPersonelId,
            tblCustomerId: data.tblCustomerId ? data.tblCustomerId : data.TblCustomerId,
            Txt: this.Rows.MatnSms,
            PhoneNUm: data.PerMobile,
            tblUserGrpInsert: this.$session.get('UserInfo').tblUserGrpId,
            tblUserid: this.$session.get('UserInfo').tblUserId,
          },
          ArryfildValue: {
            ListDataCRM: [
              {
                tblPersonelId: this.PerId,
                tblCustomerId: data.tblCustomerId,
                Txt: '',
                PhoneNUm: data.PerMobile,
                tblUserGrpInsert: this.$session.get('UserInfo').tblUserGrpId,
                tblUserid: this.$session.get('UserInfo').tblUserId,
                TblPersonalId: data.tblPersonelId,
                CustomerName: '',
                CustomerCode: data.CustomerCode,
                CodeBazaryabi: 0,
                FullName: '',
                PerMobile: '',
                UserName: '',
                Pss: '',
                UserMobile: '',
              },
            ],
          },
        }
        DataAxiosSend.ArryfildValue.ListDataCRM[0].CustomerName = data.CustomerName
        DataAxiosSend.ArryfildValue.ListDataCRM[0].CustomerCode = data.CustomerCode
        DataAxiosSend.ArryfildValue.ListDataCRM[0].FullName = data.FullName
        DataAxiosSend.ArryfildValue.ListDataCRM[0].PerMobile = data.PerMobile
        DataAxiosSend.ArryfildValue.ListDataCRM[0].UserName = data.UserName
        DataAxiosSend.ArryfildValue.ListDataCRM[0].Pss = data.Pass
        DataAxiosSend.ArryfildValue.ListDataCRM[0].UserMobile = ''
        DataAxiosSend.ArryfildValue.ListDataCRM[0].Txt = this.Rows.MatnSms
        DataAxiosSend.ArryfildValue.ListDataCRM[0].PssIsEncrypt = false

        this.$PostData(DataAxiosSend).then((result) => {
          if (result.status == 'success') {
            this.$mySweetDefaultTost('عملیات موفق', 'پیامک با موفقیت برای کاربر ارسال شد', 'success', 2000)
            this.Reload()
            // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: this.CustomerId } })
            this.$FindeCustomerById('DetailCustomer',this.CustomerId ,false,null)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ارسال پیامک بوجود آمده است دوباره تلاش کنید', 'error', 2000)
            this.Reload()
          }
        })
      } else {
        this.$mySweetDefaultTost('اطلاعات شماره تلفن همراه این پرسنل یافت نشد ، تلفن پرسنل را تکمیل و دوباره تلاش کنید', 'عدم اطلاعات تلفن همراه', 'warning', 3000)
        this.Reload()
      }
    },
    SendSmsOnGrid(data) {
      this.$mySweetDefaultTost('رمز جدید برای کاربر ایجاد شد و مشخصات سامانه ، ارسال گردید', 'عملیات موفق', 'success', 3000)
      data.Pass = this.getRndInteger(10000, 999999) + ''
      // console.log(data)
      this.SendSms(data)
    },
    EditCrmUser() {
      if (this.$ValidForm('PersonelCRM')) {
        this.DataAxios.tblUserGrpInsert = this.$session.get('UserInfo').tblUserGrpId
        this.DataAxios.tblUserid = this.$session.get('UserInfo').tblUserId
        this.DataAxiosSend.Method = 'PUT'
        this.DataAxiosSend.ArryfildValue = this.DataAxios
        this.$PostData(this.DataAxiosSend).then((result) => {
          if (result.status == 'Success') {
            this.$SweetQustion('ارسال پیامک', 'اطلاعات سامانه CRM  برای پرسنل مربوطه ارسال گردد؟', 'info', 'ارسال پیامک', 'انصراف', this.DataAxios, this.SendSms, this.cancelsms)
            this.GetDataPersonel()
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی در ثبت کاربر سامانه CRM  به وجود آماده', 'error', 2000)
          }
        })
      }
    },
    GetRowsSmsTemplate() {
      let DataAxiosSearch = { ArryfildValue: { ShobeId: 1, SoftwareId: 2 } }
      DataAxiosSearch.Action = 'SmsTemplate/GetSmsTemplateInCRM'
      DataAxiosSearch.Method = 'post'
      this.$PostData(DataAxiosSearch)
        .then((result) => {
          if (result.Status == 'Ok') {
            result.Data.forEach((el) => {
              if (el.Id == 455056) {
                this.Rows = el
              }
            })
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    cancelsms() {
      this.$toasted.success('ویرایش اطلاعات با موفقیت انجام شد', {
        duration: 2000,
      })
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: this.DataAxios.tblCustomerId } })
      this.$FindeCustomerById('DetailCustomer',this.DataAxios.tblCustomerId,false,null)
    },
  },
  mounted() {
    this.GetRowsSmsTemplate()
    if (this.tblCustomerId) {
      this.AddMode = 1
      // this.DataAxios.tblCustomerId=this.tblCustomerId
      this.DataAxios = this.Personel
      this.DataAxios.UserName = this.Personel.PerMobile
      this.DataAxios.tblPersonelId = this.Personel.Id
      this.DataAxios.PerMobile = this.Personel.PerMobile
      this.ReRandomPass()
    }
    this.ReRandomPass()

    this.GetDataPersonel()
    this.GetColumn()
  },
  props: ['tblCustomerId', 'Personel'],
}
</script>
<style scoped></style>
